import { api } from "~/utils/api"

export function useAllocationStoreMap() {
  return api.allocation.getAllocationStoreMap.useQuery()
}
